export enum FEATURES {
  CHANGE_INSTALLATION_ADDRESS = 'change_installation_address',
  MAINTENANCE = 'maintenance',
  PAGE_ENTERTAINMENT = 'page_entertainment',
  SERVICE_PAGE = 'service_page',
  STREAMING_IN_TV_PACKAGES = 'streaming_in_tv_packages',
  STREAMING_SKYSHOWTIME_ENABLED = 'streaming_skyshowtime_enabled',
  STREAMING_VIDEOLAND_ENABLED = 'streaming_videoland_enabled',
  U2C_MIGRATION_MESSAGE = 'u2c_migration',
  PAYMENT_ARRANGEMENT_WEBVIEW_ENABLED = 'payment_arrangement_webview_enabled',
  PRODUCT_SERVICE = 'product_service',
  CANCEL_TV_HARDWARE = 'cancel_tv_hardware',
}

export enum FEATURE_STATES {
  DEFAULT = 'on',
  ON = 'on',
  OFF = 'off',
  REDIRECT = 'redirect',
}
